import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface StockStatus {
  totalProducts: number;
  productsInStock: number;
}

export const useStockStatus = (notificationId: string) => {
  return useQuery({
    queryKey: ['stock-status', notificationId],
    queryFn: async (): Promise<StockStatus> => {
      try {
        const { data, error } = await supabase
          .rpc('get_stock_status', { p_notification_id: notificationId });

        if (error) {
          console.error('RPC error in get_stock_status:', error);
          throw error;
        }

        const result = data?.[0] || { total_products: 0, products_in_stock: 0 };
        
        return {
          totalProducts: Number(result.total_products || 0),
          productsInStock: Number(result.products_in_stock || 0)
        };
      } catch (err) {
        console.error('Error fetching stock status:', err);
        throw err;
      }
    },
    staleTime: 2 * 60 * 1000, // 2 minutes - fresher data
    gcTime: 5 * 60 * 1000, // 5 minutes cache - keep in memory longer
    refetchInterval: false,
    refetchOnWindowFocus: false,
    retry: 1,
  });
};
